import * as ambassadorWixContactsV4Contact from './contacts-v4-contact-contacts.http.js';
import * as ambassadorWixContactsV4ContactTypes from './contacts-v4-contact-contacts.types.js';
import * as ambassadorWixContactsV4ContactUniversalTypes from './contacts-v4-contact-contacts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createContact(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixContactsV4ContactUniversalTypes.CreateContactRequest,
  ambassadorWixContactsV4ContactTypes.CreateContactRequest,
  ambassadorWixContactsV4ContactUniversalTypes.CreateContactResponse,
  ambassadorWixContactsV4ContactTypes.CreateContactResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.createContact(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/contacts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateContact(): __PublicMethodMetaInfo<
  'PATCH',
  { contactId: string },
  ambassadorWixContactsV4ContactUniversalTypes.UpdateContactRequest,
  ambassadorWixContactsV4ContactTypes.UpdateContactRequest,
  ambassadorWixContactsV4ContactUniversalTypes.UpdateContactResponse,
  ambassadorWixContactsV4ContactTypes.UpdateContactResponse
> {
  const payload = { contactId: ':contactId' } as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.updateContact(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v4/contacts/{contactId}',
    pathParams: { contactId: 'contactId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function mergeContacts(): __PublicMethodMetaInfo<
  'POST',
  { targetContactId: string },
  ambassadorWixContactsV4ContactUniversalTypes.MergeContactsRequest,
  ambassadorWixContactsV4ContactTypes.MergeContactsRequest,
  ambassadorWixContactsV4ContactUniversalTypes.MergeContactsResponse,
  ambassadorWixContactsV4ContactTypes.MergeContactsResponse
> {
  const payload = { targetContactId: ':targetContactId' } as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.mergeContacts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/contacts/{targetContactId}/merge',
    pathParams: { targetContactId: 'targetContactId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function previewMergeContacts(): __PublicMethodMetaInfo<
  'POST',
  { targetContactId: string },
  ambassadorWixContactsV4ContactUniversalTypes.PreviewMergeContactsRequest,
  ambassadorWixContactsV4ContactTypes.PreviewMergeContactsRequest,
  ambassadorWixContactsV4ContactUniversalTypes.PreviewMergeContactsResponse,
  ambassadorWixContactsV4ContactTypes.PreviewMergeContactsResponse
> {
  const payload = { targetContactId: ':targetContactId' } as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.previewMergeContacts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/contacts/{targetContactId}/preview-merge',
    pathParams: { targetContactId: 'targetContactId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteContact(): __PublicMethodMetaInfo<
  'DELETE',
  { contactId: string },
  ambassadorWixContactsV4ContactUniversalTypes.DeleteContactRequest,
  ambassadorWixContactsV4ContactTypes.DeleteContactRequest,
  ambassadorWixContactsV4ContactUniversalTypes.DeleteContactResponse,
  ambassadorWixContactsV4ContactTypes.DeleteContactResponse
> {
  const payload = { contactId: ':contactId' } as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.deleteContact(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v4/contacts/{contactId}',
    pathParams: { contactId: 'contactId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function labelContact(): __PublicMethodMetaInfo<
  'POST',
  { contactId: string },
  ambassadorWixContactsV4ContactUniversalTypes.LabelContactRequest,
  ambassadorWixContactsV4ContactTypes.LabelContactRequest,
  ambassadorWixContactsV4ContactUniversalTypes.LabelContactResponse,
  ambassadorWixContactsV4ContactTypes.LabelContactResponse
> {
  const payload = { contactId: ':contactId' } as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.labelContact(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/contacts/{contactId}/labels',
    pathParams: { contactId: 'contactId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unlabelContact(): __PublicMethodMetaInfo<
  'DELETE',
  { contactId: string },
  ambassadorWixContactsV4ContactUniversalTypes.UnlabelContactRequest,
  ambassadorWixContactsV4ContactTypes.UnlabelContactRequest,
  ambassadorWixContactsV4ContactUniversalTypes.UnlabelContactResponse,
  ambassadorWixContactsV4ContactTypes.UnlabelContactResponse
> {
  const payload = { contactId: ':contactId' } as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.unlabelContact(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v4/contacts/{contactId}/labels',
    pathParams: { contactId: 'contactId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listContacts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixContactsV4ContactUniversalTypes.ListContactsRequest,
  ambassadorWixContactsV4ContactTypes.ListContactsRequest,
  ambassadorWixContactsV4ContactUniversalTypes.ListContactsResponse,
  ambassadorWixContactsV4ContactTypes.ListContactsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.listContacts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/contacts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryContacts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixContactsV4ContactUniversalTypes.QueryContactsRequest,
  ambassadorWixContactsV4ContactTypes.QueryContactsRequest,
  ambassadorWixContactsV4ContactUniversalTypes.QueryContactsResponse,
  ambassadorWixContactsV4ContactTypes.QueryContactsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.queryContacts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/contacts/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listFacets(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixContactsV4ContactUniversalTypes.ListFacetsRequest,
  ambassadorWixContactsV4ContactTypes.ListFacetsRequest,
  ambassadorWixContactsV4ContactUniversalTypes.ListFacetsResponse,
  ambassadorWixContactsV4ContactTypes.ListFacetsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixContactsV4Contact.listFacets(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/contacts/facets',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryFacets(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixContactsV4ContactUniversalTypes.QueryFacetsRequest,
  ambassadorWixContactsV4ContactTypes.QueryFacetsRequest,
  ambassadorWixContactsV4ContactUniversalTypes.QueryFacetsResponse,
  ambassadorWixContactsV4ContactTypes.QueryFacetsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixContactsV4Contact.queryFacets(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/contacts/facets/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteContacts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixContactsV4ContactUniversalTypes.BulkDeleteContactsRequest,
  ambassadorWixContactsV4ContactTypes.BulkDeleteContactsRequest,
  ambassadorWixContactsV4ContactUniversalTypes.BulkDeleteContactsResponse,
  ambassadorWixContactsV4ContactTypes.BulkDeleteContactsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.bulkDeleteContacts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/bulk/contacts/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateContacts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixContactsV4ContactUniversalTypes.BulkUpdateContactsRequest,
  ambassadorWixContactsV4ContactTypes.BulkUpdateContactsRequest,
  ambassadorWixContactsV4ContactUniversalTypes.BulkUpdateContactsResponse,
  ambassadorWixContactsV4ContactTypes.BulkUpdateContactsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.bulkUpdateContacts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/bulk/contacts/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkLabelAndUnlabelContacts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixContactsV4ContactUniversalTypes.BulkLabelAndUnlabelContactsRequest,
  ambassadorWixContactsV4ContactTypes.BulkLabelAndUnlabelContactsRequest,
  ambassadorWixContactsV4ContactUniversalTypes.BulkLabelAndUnlabelContactsResponse,
  ambassadorWixContactsV4ContactTypes.BulkLabelAndUnlabelContactsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixContactsV4Contact.bulkLabelAndUnlabelContacts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/bulk/contacts/add-remove-labels',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getContact(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixContactsV4ContactUniversalTypes.GetContactRequest,
  ambassadorWixContactsV4ContactTypes.GetContactRequest,
  ambassadorWixContactsV4ContactUniversalTypes.GetContactResponse,
  ambassadorWixContactsV4ContactTypes.GetContactResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixContactsV4Contact.getContact(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/contacts/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Contact as ContactOriginal,
  ContactSource as ContactSourceOriginal,
  ContactSourceType as ContactSourceTypeOriginal,
  ContactSourceTypeWithLiterals as ContactSourceTypeWithLiteralsOriginal,
  ContactActivity as ContactActivityOriginal,
  ContactActivityType as ContactActivityTypeOriginal,
  ContactActivityTypeWithLiterals as ContactActivityTypeWithLiteralsOriginal,
  ActivityIcon as ActivityIconOriginal,
  PrimaryContactInfo as PrimaryContactInfoOriginal,
  Image as ImageOriginal,
  ContactInfo as ContactInfoOriginal,
  ContactName as ContactNameOriginal,
  ContactEmailsWrapper as ContactEmailsWrapperOriginal,
  ContactEmail as ContactEmailOriginal,
  EmailTag as EmailTagOriginal,
  EmailTagWithLiterals as EmailTagWithLiteralsOriginal,
  ContactPhonesWrapper as ContactPhonesWrapperOriginal,
  ContactPhone as ContactPhoneOriginal,
  PhoneTag as PhoneTagOriginal,
  PhoneTagWithLiterals as PhoneTagWithLiteralsOriginal,
  ContactAddressesWrapper as ContactAddressesWrapperOriginal,
  ContactAddress as ContactAddressOriginal,
  AddressTag as AddressTagOriginal,
  AddressTagWithLiterals as AddressTagWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  AssigneesWrapper as AssigneesWrapperOriginal,
  LabelsWrapper as LabelsWrapperOriginal,
  ExtendedFieldsWrapper as ExtendedFieldsWrapperOriginal,
  LocationsWrapper as LocationsWrapperOriginal,
  ContactPicture as ContactPictureOriginal,
  ImageProvider as ImageProviderOriginal,
  ImageProviderWithLiterals as ImageProviderWithLiteralsOriginal,
  SegmentsWrapper as SegmentsWrapperOriginal,
  PrimaryEmail as PrimaryEmailOriginal,
  SubscriptionStatus as SubscriptionStatusOriginal,
  SubscriptionStatusWithLiterals as SubscriptionStatusWithLiteralsOriginal,
  EmailDeliverabilityStatus as EmailDeliverabilityStatusOriginal,
  EmailDeliverabilityStatusWithLiterals as EmailDeliverabilityStatusWithLiteralsOriginal,
  PrimaryPhone as PrimaryPhoneOriginal,
  PhoneDeliverabilityStatus as PhoneDeliverabilityStatusOriginal,
  PhoneDeliverabilityStatusWithLiterals as PhoneDeliverabilityStatusWithLiteralsOriginal,
  MemberInfo as MemberInfoOriginal,
  MemberStatus as MemberStatusOriginal,
  MemberStatusWithLiterals as MemberStatusWithLiteralsOriginal,
  ProfileInfo as ProfileInfoOriginal,
  PrivacyStatus as PrivacyStatusOriginal,
  PrivacyStatusWithLiterals as PrivacyStatusWithLiteralsOriginal,
  UserInfo as UserInfoOriginal,
  Role as RoleOriginal,
  RoleWithLiterals as RoleWithLiteralsOriginal,
  SessionInfo as SessionInfoOriginal,
  GroupInfo as GroupInfoOriginal,
  ContactSubmitted as ContactSubmittedOriginal,
  ContactChanged as ContactChangedOriginal,
  ContactEmailSubscriptionUpdated as ContactEmailSubscriptionUpdatedOriginal,
  ContactPhoneSubscriptionUpdated as ContactPhoneSubscriptionUpdatedOriginal,
  ContactPrimaryInfoUpdated as ContactPrimaryInfoUpdatedOriginal,
  PrimarySubscriptionStatus as PrimarySubscriptionStatusOriginal,
  LastActivityUpdate as LastActivityUpdateOriginal,
  CreateContactRequest as CreateContactRequestOriginal,
  CreateContactResponse as CreateContactResponseOriginal,
  DuplicateContactExists as DuplicateContactExistsOriginal,
  UpdateContactRequest as UpdateContactRequestOriginal,
  UpdateContactResponse as UpdateContactResponseOriginal,
  MergeContactsRequest as MergeContactsRequestOriginal,
  MergeContactsResponse as MergeContactsResponseOriginal,
  ContactMerged as ContactMergedOriginal,
  PreviewMergeContactsRequest as PreviewMergeContactsRequestOriginal,
  PreviewMergeContactsResponse as PreviewMergeContactsResponseOriginal,
  DeleteContactRequest as DeleteContactRequestOriginal,
  DeleteContactResponse as DeleteContactResponseOriginal,
  LabelContactRequest as LabelContactRequestOriginal,
  LabelContactResponse as LabelContactResponseOriginal,
  UnlabelContactRequest as UnlabelContactRequestOriginal,
  UnlabelContactResponse as UnlabelContactResponseOriginal,
  LabelAndUnlabelContactRequest as LabelAndUnlabelContactRequestOriginal,
  LabelAndUnlabelContactResponse as LabelAndUnlabelContactResponseOriginal,
  ListContactsRequest as ListContactsRequestOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  ContactFieldSet as ContactFieldSetOriginal,
  ContactFieldSetWithLiterals as ContactFieldSetWithLiteralsOriginal,
  ListContactsResponse as ListContactsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  QueryContactsRequest as QueryContactsRequestOriginal,
  Query as QueryOriginal,
  QueryContactsResponse as QueryContactsResponseOriginal,
  ListFacetsRequest as ListFacetsRequestOriginal,
  ListFacetsResponse as ListFacetsResponseOriginal,
  ContactsFacet as ContactsFacetOriginal,
  ContactsFacetType as ContactsFacetTypeOriginal,
  ContactsFacetTypeWithLiterals as ContactsFacetTypeWithLiteralsOriginal,
  QueryFacetsRequest as QueryFacetsRequestOriginal,
  QueryFacetsResponse as QueryFacetsResponseOriginal,
  BulkDeleteContactsRequest as BulkDeleteContactsRequestOriginal,
  BulkDeleteContactsResponse as BulkDeleteContactsResponseOriginal,
  BulkUpdateContactsRequest as BulkUpdateContactsRequestOriginal,
  BulkUpdateContactsResponse as BulkUpdateContactsResponseOriginal,
  BulkLabelAndUnlabelContactsRequest as BulkLabelAndUnlabelContactsRequestOriginal,
  BulkLabelAndUnlabelContactsResponse as BulkLabelAndUnlabelContactsResponseOriginal,
  BulkUpsertContactsRequest as BulkUpsertContactsRequestOriginal,
  BulkUpsertContactsResponse as BulkUpsertContactsResponseOriginal,
  Action as ActionOriginal,
  ActionWithLiterals as ActionWithLiteralsOriginal,
  Error as ErrorOriginal,
  Metadata as MetadataOriginal,
  Item as ItemOriginal,
  BulkUpsertContactsResponseMetadata as BulkUpsertContactsResponseMetadataOriginal,
  UpsertContactRequest as UpsertContactRequestOriginal,
  UpsertContactResponse as UpsertContactResponseOriginal,
  UpsertContactResponseAction as UpsertContactResponseActionOriginal,
  UpsertContactResponseActionWithLiterals as UpsertContactResponseActionWithLiteralsOriginal,
  GeneratePictureUploadUrlRequest as GeneratePictureUploadUrlRequestOriginal,
  GeneratePictureUploadUrlResponse as GeneratePictureUploadUrlResponseOriginal,
  GetContactRequest as GetContactRequestOriginal,
  GetContactResponse as GetContactResponseOriginal,
  GetContactResponseType as GetContactResponseTypeOriginal,
  GetContactResponseTypeWithLiterals as GetContactResponseTypeWithLiteralsOriginal,
  SyncSubmitContactRequest as SyncSubmitContactRequestOriginal,
  SubmitOperation as SubmitOperationOriginal,
  SubmitOperationWithLiterals as SubmitOperationWithLiteralsOriginal,
  SyncSubmitContactResponse as SyncSubmitContactResponseOriginal,
  CountContactsRequest as CountContactsRequestOriginal,
  CountContactsResponse as CountContactsResponseOriginal,
  SearchContactsRequest as SearchContactsRequestOriginal,
  Search as SearchOriginal,
  SearchPagingMethodOneOf as SearchPagingMethodOneOfOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  SearchContactsResponse as SearchContactsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkAddSegmentToContactsRequest as BulkAddSegmentToContactsRequestOriginal,
  BulkAddSegmentToContactsResponse as BulkAddSegmentToContactsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  ContactAddedToSegment as ContactAddedToSegmentOriginal,
  BulkRemoveSegmentFromContactsRequest as BulkRemoveSegmentFromContactsRequestOriginal,
  BulkRemoveSegmentFromContactsResponse as BulkRemoveSegmentFromContactsResponseOriginal,
  ContactRemovedFromSegment as ContactRemovedFromSegmentOriginal,
  ListContactIdsBySegmentRequest as ListContactIdsBySegmentRequestOriginal,
  ListContactIdsBySegmentResponse as ListContactIdsBySegmentResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateContactApplicationErrors as CreateContactApplicationErrorsOriginal,
  UpdateContactApplicationErrors as UpdateContactApplicationErrorsOriginal,
  MergeContactsApplicationErrors as MergeContactsApplicationErrorsOriginal,
  PreviewMergeContactsApplicationErrors as PreviewMergeContactsApplicationErrorsOriginal,
  DeleteContactApplicationErrors as DeleteContactApplicationErrorsOriginal,
  LabelContactApplicationErrors as LabelContactApplicationErrorsOriginal,
  UnlabelContactApplicationErrors as UnlabelContactApplicationErrorsOriginal,
  ListContactsApplicationErrors as ListContactsApplicationErrorsOriginal,
  QueryContactsApplicationErrors as QueryContactsApplicationErrorsOriginal,
  BulkDeleteContactsApplicationErrors as BulkDeleteContactsApplicationErrorsOriginal,
  BulkLabelAndUnlabelContactsApplicationErrors as BulkLabelAndUnlabelContactsApplicationErrorsOriginal,
  GetContactApplicationErrors as GetContactApplicationErrorsOriginal,
} from './contacts-v4-contact-contacts.types.js';
